tetloose.forms = function () {
    var $form = $('form'),
        $br = $form.find('br'),
        $p = $form.find('p');

    if ($br) {
        $br.remove();
    }

    $p.each(function() {
        var $t = $(this);

        $t.contents().unwrap().siblings('p').remove();
    });
};
